module.exports = __webpack_public_path__ + "img/vyttra_gif_c.4b1a3ff9.gif";